import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  HomeIcon,
  Squares2X2Icon,
  SparklesIcon,
  UserIcon,
  ShoppingCartIcon
} from '@heroicons/react/24/outline';
import { useAuth } from '../../contexts/AuthContext';
import { useCart } from '../../contexts/CartContext';
import { useDesign } from '../../contexts/DesignContext';

const isActiveRoute = (pathname, target) => {
  if (target === '/') return pathname === '/';
  return pathname.startsWith(target);
};

const MobileBottomNav = () => {
  const location = useLocation();
  const { user } = useAuth();
  const { cartItemsCount } = useCart();
  const { designConfig } = useDesign();

  const items = [
    { key: 'home', label: 'Home', to: '/', icon: HomeIcon },
    { key: 'categories', label: 'Categories', to: '/categories', icon: Squares2X2Icon },
    { key: 'new', label: 'New Arrivals', to: '/products', icon: SparklesIcon },
    { key: 'account', label: 'Account', to: user ? '/profile' : '/login', icon: UserIcon },
    { key: 'cart', label: 'Cart', to: '/cart', icon: ShoppingCartIcon, badge: cartItemsCount }
  ];

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 md:hidden border-t"
      style={{
        backgroundColor: designConfig.header_bg || '#FFFFFF',
        borderTopColor: 'rgba(0,0,0,0.08)',
        zIndex: 99999
      }}
      aria-label="Bottom navigation"
    >
      <div className="max-w-md mx-auto px-2">
        <div className="grid grid-cols-5 h-16">
          {items.map((item) => {
            const active = isActiveRoute(location.pathname, item.to);
            const Icon = item.icon;
            return (
              <Link
                key={item.key}
                to={item.to}
                className="flex flex-col items-center justify-center gap-1 relative"
                style={{
                  color: active ? (designConfig.primary_color || '#7C3AED') : (designConfig.text_color || '#374151'),
                  opacity: active ? 1 : 0.75
                }}
              >
                <div className="relative">
                  <Icon className="w-6 h-6" />
                  {item.key === 'cart' && item.badge > 0 && (
                    <span className="absolute -top-1 -right-2 bg-red-500 text-white text-[10px] rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1">
                      {item.badge}
                    </span>
                  )}
                </div>
                <span className="text-[10px] leading-none">{item.label}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default MobileBottomNav;
